export enum ApiServicesPaymentMethod {
	PrePayment = 'PrePayment',
	PostPayment = 'PostPayment',
}
